import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  withMobileDialog,
  IconButton,
  Icon,
  ListItemIcon,
  ListSubheader,
  Menu,
  MenuItem,
  Tooltip,
  Checkbox,
} from '@material-ui/core';
import styles from './styles';

export class DashboardActionsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { menuElement: null };
  }

  handleClick = (event) => {
    this.setState({ menuElement: event.currentTarget });
  }

  handleClose = () => {
    this.setState({ menuElement: null });
  }

  handleAction = (handler) => () => {
    this.handleClose();
    handler();
  }

  render() {
    const {
      classes,
      selectedDashboard,
      onCopy,
      onDelete,
      onEdit,
      onSubscriptionChange,
      onShareChange,
      onExport,
      onSave,
      isAdmin,
      saveEnabled,
      subscribeEnabled,
      isSubscribedToDashboard,
      onOrganizationExposedChange,
      handleFilterClick,
      fullScreen,
    } = this.props;
    const { menuElement } = this.state;

    return (
      <div>
        <Tooltip title="Actions">
          <IconButton
            aria-owns={menuElement
              ? 'dashboard-actions-menu'
              : null}
            aria-haspopup="true"
            name="dashboard-actions"
            onClick={this.handleClick}
            color="inherit"
          >
            <Icon>
              more_vert
            </Icon>
          </IconButton>
        </Tooltip>
        <Menu
          id="dashboard-actions-menu"
          anchorEl={menuElement}
          open={Boolean(menuElement)}
          onClose={this.handleClose}
        >
          {
            isAdmin
              && selectedDashboard.id !== -1
              && (
                <span>
                  <ListSubheader>Admin Settings</ListSubheader>
                  <MenuItem
                    name="shared-dashboard-switch"
                    className={classes.toggleMenuItem}
                    onClick={onShareChange}
                  >
                    <ListItemIcon>
                      <Icon>
                        public
                      </Icon>
                    </ListItemIcon>
                    <div className={classes.toggleMenuItemContainer}>
                      <div className={classes.toggleMenuItemText}>
                        Shared
                      </div>
                      <Checkbox
                        checked={selectedDashboard.organizationExposed}
                        className={classes.toggleMenuItemSwitch}
                        color="primary"
                        value={selectedDashboard.organizationExposed}
                        onClick={onOrganizationExposedChange}
                      />
                    </div>
                  </MenuItem>
                </span>
              )
          }

          <ListSubheader>Events</ListSubheader>

          <MenuItem
            name="export-dashboard-action"
            onClick={this.handleAction(onExport)}
          >
            <ListItemIcon>
              <Icon>
                cloud_download
              </Icon>
            </ListItemIcon>
            Export
          </MenuItem>

          <ListSubheader>Dashboard</ListSubheader>

          {
            fullScreen
              && (
                <MenuItem
                  name="set-dashboard-filter-action"
                  onClick={this.handleAction(handleFilterClick)}
                >
                  <ListItemIcon>
                    <Icon>
                      filter_list
                    </Icon>
                  </ListItemIcon>
                  Filter
                </MenuItem>
              )
          }

          {
            ((isAdmin || !selectedDashboard.organizationExposed) && selectedDashboard.id !== -1)
              && (
                <MenuItem
                  name="save-dashboard-action"
                  onClick={
                    saveEnabled
                      ? this.handleAction(onSave)
                      : () => {}
                  }
                  disableRipple={!saveEnabled}
                  className={!saveEnabled
                    ? classes.disabled
                    : ''}
                >
                  <ListItemIcon>
                    <Icon
                      className={!saveEnabled
                        ? classes.disabled
                        : ''}
                    >
                      save
                    </Icon>
                  </ListItemIcon>
                  Save
                </MenuItem>
              )
          }

          {
            ((isAdmin || !selectedDashboard.organizationExposed) && selectedDashboard.id !== -1)
              && (
                <MenuItem
                  name="edit-dashboard-action"
                  onClick={this.handleAction(onEdit)}
                >
                  <ListItemIcon>
                    <Icon>
                      edit
                    </Icon>
                  </ListItemIcon>
                  Edit
                </MenuItem>
              )
          }

          <MenuItem
            name="copy-dashboard-action"
            onClick={this.handleAction(onCopy)}
          >
            <ListItemIcon>
              <Icon>
                file_copy
              </Icon>
            </ListItemIcon>
            Copy
          </MenuItem>

          {
            ((isAdmin || !selectedDashboard.organizationExposed) && selectedDashboard.id !== -1)
              && (
                <MenuItem
                  name="delete-dashboard-action"
                  onClick={this.handleAction(onDelete)}
                >
                  <ListItemIcon>
                    <Icon>
                      delete
                    </Icon>
                  </ListItemIcon>
                  Delete
                </MenuItem>
              )
          }

          {
            subscribeEnabled
            && (
              <div>
                <ListSubheader>Notifications</ListSubheader>

                <MenuItem
                  name="subscribed-dashboard-switch"
                  className={classes.toggleMenuItem}
                  onClick={onSubscriptionChange}
                >
                  <ListItemIcon>
                    <Icon>
                      notifications
                    </Icon>
                  </ListItemIcon>
                  <div className={classes.toggleMenuItemContainer}>
                    <div className={classes.toggleMenuItemText}>
                      Subscribed
                    </div>
                    <Checkbox
                      className={classes.toggleMenuItemSwitch}
                      color="primary"
                      checked={isSubscribedToDashboard}
                      value={isSubscribedToDashboard}
                      onClick={onSubscriptionChange}
                    />
                  </div>
                </MenuItem>
              </div>
            )
          }
        </Menu>
      </div>
    );
  }
}

DashboardActionsComponent.propTypes = {
  classes: PropTypes.object,
  selectedDashboard: PropTypes.object,
  onSubscriptionChange: PropTypes.func,
  onOrganizationExposedChange: PropTypes.func,
  onShareChange: PropTypes.func,
  onCopy: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onExport: PropTypes.func,
  onSave: PropTypes.func,
  isAdmin: PropTypes.bool,
  saveEnabled: PropTypes.bool,
  subscribeEnabled: PropTypes.bool,
  isSubscribedToDashboard: PropTypes.bool,
  handleFilterClick: PropTypes.func,
  fullScreen: PropTypes.bool,
};

DashboardActionsComponent.defaultProps = {
  classes: {},
  selectedDashboard: {},
  onSubscriptionChange: () => {},
  onOrganizationExposedChange: () => {},
  onShareChange: () => {},
  onCopy: () => {},
  onEdit: () => {},
  onDelete: () => {},
  onExport: () => {},
  onSave: () => {},
  isAdmin: false,
  saveEnabled: false,
  subscribeEnabled: false,
  isSubscribedToDashboard: false,
  handleFilterClick: () => {},
  fullScreen: false,
};

export default withMobileDialog({ breakpoints: 'xs' })(withStyles(styles)(DashboardActionsComponent));
